/**
 * Constants Used For container Component.
 */
const HOME_PAGE_CONTAINER_CONSTANTS = {
  GENERAL_ROUTING: 'General Routing/Communication',
  HOME_PAGE_OFFERS: 'Home Page Offers',
  // DISPOSITION_START_ORDER: 'Disposition - Start Order',
  MARKETING_HERO_3: 'Marketing Hero 3',
  // DISPOSITION_LOCALIZED: 'Disposition - Localized',
  CRM_SIGNUP: 'CRM SignUP',
  BROWSER_CATEGORIES: 'Browser Categories',
  OFFERS_DEALS: 'Offers and Deals',
  DISPOSITION: 'disposition',
  CAROUSAL: 'carousalComponent',
  ORDERSERV: 'orderServComponent',
  ROUTING: 'routingComponent',
  CRM: 'crmSignUp',
  ORDER_IT_AGAIN: 'Order it again',
  WELCOME_MESSAGE: 'Welcome Message',
};

export default HOME_PAGE_CONTAINER_CONSTANTS;
